export default __webpack_public_path__ + "static/media/Strugani 22.4509a3ba.jpg";